module.exports = __webpack_public_path__ + "static/media/the-simple-shellfish-sea-squirts.dc2e24c9.jpg";